import React from 'react';
import RevealOnScroll from './RevealOnScroll';

const Hero: React.FC = () => {
  return (
    <section className="relative pt-28 pb-12 md:pt-48 md:pb-40 overflow-hidden bg-brand-900 min-h-[85vh] flex items-center">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/OTL_1080P.mp4" type="video/mp4" />
        </video>

        {/* Overlays for readability */}
        <div className="absolute inset-0 bg-brand-900/70 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <RevealOnScroll>
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-tight drop-shadow-2xl mb-6 md:mb-8">
            Shop <span className="text-brand-300">Sri Lankan Stores</span> & Ship to <span className="text-white relative inline-block">
              Maldives
              <svg className="absolute w-full h-2 md:h-3 -bottom-1 left-0 text-brand-500" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
              </svg>
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-2xl text-brand-50 max-w-3xl mx-auto leading-relaxed drop-shadow-lg font-medium mb-8 md:mb-12 px-2">
            OTL Express delivers the brands you love right to your doorstep. Save big on international shipping with our premium consolidation service.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-center">
            <button onClick={() => window.location.href = "/auth/login"} className="w-full sm:w-auto bg-brand-600 hover:bg-brand-500 text-white text-lg md:text-xl font-bold px-8 py-3.5 md:px-10 md:py-4 rounded-full shadow-2xl transition-all transform hover:-translate-y-1 hover:shadow-brand-500/50 ring-4 ring-brand-600/30">
              Get Your Free Address
            </button>
            <button
              className="w-full sm:w-auto bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border border-white/40 text-lg md:text-xl font-bold px-8 py-3.5 md:px-10 md:py-4 rounded-full shadow-lg transition-all transform hover:-translate-y-1"
            >
              How It Works
            </button>
          </div>

          <div className="mt-8 md:mt-12 flex items-center justify-center gap-2 text-brand-200 text-sm font-medium animate-fade-in">
            <span className="flex items-center gap-1">
              <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>
              Trusted by 1000+ Shoppers
            </span>
            <span className="w-1 h-1 bg-brand-400 rounded-full"></span>
            <span>Rated 5/5 Stars</span>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default Hero;